import { getLocale } from './getLocale';

export const currencyFormater = (currency = 'USD', locale?: string): Intl.NumberFormat => {
  const currentLocale = locale ?? getLocale();

  const formatter = new Intl.NumberFormat(currentLocale, {
    style: 'currency',
    currency,
  });

  return formatter;
};

export const formatCurrency = (
  value: number,
  currency?: string,
  keepZeroCents?: boolean,
  locale?: string
): string => {
  const formattedString = currencyFormater(currency ?? 'USD', locale).format(value);

  if (!keepZeroCents && formattedString.endsWith('.00')) {
    return formattedString.substr(0, formattedString.length - 3);
  }

  return formattedString;
};
